import defaultProductImage from "../assets/images/miele-default.jpg";

/** Immagine mostrata quando un prodotto non ha ancora una foto caricata. */
export const DEFAULT_PRODUCT_IMAGE = defaultProductImage;

export function productImage(url: string | null | undefined): string {
	return url || DEFAULT_PRODUCT_IMAGE;
}
